import React from 'react';
import { FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';

export const AdditionalInfoCard = ({ poNumber, setPoNumber, orderNotes, setOrderNotes }) => (
  <Card data-testid="additional-info-card">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <FileText className="h-5 w-5 text-amber-500" />
        Additional Information
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label htmlFor="poNumber">PO Number (Optional)</Label>
        <Input
          id="poNumber"
          value={poNumber}
          onChange={(e) => setPoNumber(e.target.value)}
          placeholder="Enter your PO number"
          className="mt-1"
          data-testid="po-number-input"
        />
      </div>
      <div>
        <Label htmlFor="orderNotes">Order Notes (Optional)</Label>
        <Textarea
          id="orderNotes"
          value={orderNotes}
          onChange={(e) => setOrderNotes(e.target.value)}
          placeholder="Any special instructions or notes for this order"
          className="mt-1"
          rows={3}
          data-testid="order-notes-input"
        />
      </div>
    </CardContent>
  </Card>
);
